<template>
    <div class="flex flex-col items-center justify-center">
        <div class="text-16px font-900 text-white text-center">
            Quick Command
        </div>

       
        <template v-if="quickReplyList?.list">
            <div class="flex items-center text-13px  justify-center tab w-250px mt-10px mb-10px">
                <div class=" w-50% flex items-center py-5px! justify-center tab-item"
                    :class="{ 'active': active === 0 }" @click="handleClick(0)">
                    {{ quickReplyList?.list[0]?.title }}
                </div>
                <div class="w-50% flex items-center py-5px! justify-center tab-item" :class="{ 'active': active === 1 }"
                    @click="handleClick(1)">
                    {{ quickReplyList?.list[1]?.title }}
                </div>
            </div>
            <div class="max-h-300px overflow-y-auto w-100% content-box">
                <div @click="handleQuickReply(item)" class="text-15px text-white item p-10px mb-10px"
                    v-for="item in quickReplyList?.list[active]?.children" :key="item">
                    {{ item.title }}
                </div>
            </div>
            <div class="flex items-center justify-between mt-10px w-100%" v-if="![5].includes(userStore.userInfo?.role)">
                <div class="text-12px text-white font-500 free-text ">
                    Free({{ quickReplyList?.useCount }}/{{ quickReplyList?.totalCount === -1 ? '∞' :
                        quickReplyList?.totalCount
                    }})
                </div>
                <div class="text-12px text-white font-500 ultra-text flex items-center justify-center"
                    @click="handleUltra" v-if="![4].includes(userStore.userInfo?.role)">
                    <div class="w-16px h-16px flex items-center justify-center">
                        <img src="@/assets/images/chat/chatQuickReply/ultra.svg" alt="" class="w-full h-full">
                    </div>
                    <div class="ml-4px">
                        Ultra unlock unlimited
                    </div>
                </div>
            </div>
        </template>
        <div class="py-40px" v-else>
            <van-loading type="spinner" color="#fff" size="24px" />
        </div>

        <van-popup v-model:show="show" :style="{ backgroundColor: 'transparent' }">
            <div class="privileges p-16px rounded-16px flex flex-col items-center justify-center">
                <div class="max-w-250px flex flex-col items-center justify-center">
                    <div class="w-107px h-63px"><img src="@/assets/images/chat/chatQuickReply/icon.webp" alt=""
                            class="w-100% h-100%"></div>
                    <div class="title mt-10px">
                        Unlimited privileges
                    </div>
                    <div class="text-12px text-white font-500 text-center mt-15px subscribing">
                        Subscribing to Ultra will grant you
                        unlimited privileges.
                    </div>
                    <div class="flex items-center justify-center gap-10px mt-15px">
                        <div class="text-12px text-#fff font-500 time" @click="show = false">
                            Next time
                        </div>
                        <div class="text-12px text-white font-500 subscribe-btn" @click="handleSubscribe">
                            Subscribe
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { ref } from 'vue'
import { showLoadingToast, closeToast, showFailToast } from 'vant';

const userStore = useUserStore()
const router = useRouter()
const show = ref(false)
const emit = defineEmits(['handleQuickReplyMessage'])
const active = ref(0)
const props = defineProps<{
    quickReplyList: any
}>()

const handleClick = (index: number) => {
    active.value = index
}
const handleQuickReply = (item: any) => {
    if ([3,0].includes(userStore.userInfo?.role)) {
        if (props.quickReplyList?.useCount >= props.quickReplyList?.totalCount) {
            show.value = true
            // router.push({ name: 'Vip', query: { type: 'u' } })
            return
        }
    } else if ([4].includes(userStore.userInfo?.role)) {
        if (props.quickReplyList?.useCount >= props.quickReplyList?.totalCount) {
            showFailToast('You have reached the maximum number of ultra quick replies')
            return
        }
    }
    emit('handleQuickReplyMessage', item)
}
const handleSubscribe = () => {
    router.push({ name: 'Vip', query: { type: 'u', tab: 'chat' } })
    show.value = false
}
const handleUltra = () => {
    router.push({ name: 'Vip', query: { type: 'u', tab: 'chat' } })
}
</script>
<style scoped lang="scss">
.tab {
    border-radius: 14px;
    background-color: rgba(255, 255, 255, 0.1);

    .tab-item {
        color: rgba(255, 255, 255, 0.55);
    }

    .active {
        background-color: rgba(255, 255, 255, 0.05);
        border-radius: 14px;
        border: 1px solid rgba(255, 255, 255, 0.2);
        // padding: 0 10px;
        color: #FFFFFF;
    }
}

.item {
    width: 100%;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 10px;
}

.content-box {
    // 文字淡出效果 - 使用 mask 实现
    -webkit-mask-image: linear-gradient(to bottom,
            #000 0%,
            #000 calc(100% - 40px),
            transparent 100%);

    mask-image: linear-gradient(to bottom,
            #000 0%,
            #000 calc(100% - 40px),
            transparent 100%);
}

.free-text {
    color: rgba(255, 255, 255, 0.55);
}

.ultra-text {
    color: rgba(255, 255, 255, 0.85);
    background: linear-gradient(0deg, #AD62F2 0%, #D4B3FF 100%);
    font-style: oblique;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.privileges {
    background: linear-gradient(180deg, #40166B 0%, #140325 100%);
    border-radius: 20px;
    border: 1px solid;

    .title {
        background: linear-gradient(45.00000000000003deg, #FFFDFF 0%, #C2AAFE 75%, #8B9BFE 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        font-weight: 900;
        font-size: 17px;
        color: #FFFFFF;
        color: transparent;
    }

    .subscribing {
        color: rgba(255, 255, 255, 0.7);
    }

    .time {
        background: rgba(255, 255, 255, 0.1);
        color: rgba(255, 255, 255, 0.5);
        padding: 5px 20px;
        border-radius: 15px;
        font-weight: 800;
        font-size: 14px;
        // color: #FFFFFF;
    }

    .subscribe-btn {
        // background: linear-gradient(90deg, #D6DFFF 0%, #6990FF 100%);
        background: linear-gradient(90deg, #E9D6FF 0%, #A66CFE 100%);
        color: #490D73;
        font-weight: 800;
        font-size: 15px;
        border-radius: 35px;
        padding: 5px 20px;
    }
}
</style>